import styled from 'styled-components';
import ModalCloseButton from './ModalCloseButton';

export default function UserModalHeader({ title, onClose, closeLabel = `${title} 닫기`, titleId }: {
  title: string;
  onClose: () => void;
  closeLabel?: string;
  titleId?: string;
}) {
  return <Header>
    <h2 id={titleId}>{title}</h2>
    <CloseButton aria-label={closeLabel} onClick={onClose} />
  </Header>;
}

const Header = styled.div`
  flex: none;
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: 1px solid var(--user-border);
  h2 {
    margin: 0;
    padding: 12px 64px;
    font-size: 19px;
    line-height: 1.4;
    text-align: center;
    font-family: var(--font-Pretendard-Bold);
  }
`;

const CloseButton = styled(ModalCloseButton)`
  position: absolute;
  right: 12px;
`;
